<template>
  <div id="downapp">
    <myhead title="下载APP"></myhead>
    <div class="app-down-title">选择适合您的APP下载使用吧</div>
    <div class="app-ba">
      <!-- <img src="../../assets/img/app-down-title.png" alt />
      <div class="app-ba-content">
        戴上面具
        <br />完全看不出来是聊天APP哦~
      </div> -->
      <button @click="topay" class="app-button">立即升级VIP</button>
    </div>
    
    <downAppLists></downAppLists>

    <!-- <downAppList v-show="!flag"></downAppList> -->
    <!-- <downAppListNew v-show="flag"></downAppListNew> -->

    <div class="foot-app"></div>
  </div>
</template>
<script>
import myhead from "../common/head";
import downAppLists from "../common/downAppListtest";
import downAppListNew from "../common/downAppListNew";

import util from "@/utils/util";
import store from "../../store/index";
import * as types from "../../store/types";
import { mapGetters } from "vuex";
import api from "../../api/index";
import tips from "@/estoast";

export default {
  metaInfo: {
    title: "下载APP"
  },
  name: "downapp",
  data() {
    return {
      msg: "下载APP",
      flag: false
    };
  },
  mounted() {
    this.$point.init(new Date());
    store.dispatch("hideLoading");
    var token = this.getToken;
    console.log("store里面的toekn有值" + JSON.stringify(token));
    if (token == null || token == "") {
      token = localStorage.getItem("token");
      console.log("localStorage缓存token：" + token);
      store.commit(types.LOGIN, token);
    }
    if (token == "" || token == null) {
      this.$router.push("/login");
    }
    var flag = this.getAppFlag;
    console.log("appflag:" + flag);
    if (flag) {
      this.flag = flag;
    }
  },
  methods:{
    topay(){
            this.$router.push("/vip");

    }
  },
  components: {
    myhead,
    downAppLists,
    downAppListNew
  },
  computed: {
    ...mapGetters([
      "getWxAlert",
      "loading",
      "getUserInfo",
      "getToken",
      "getUserList",
      "getAppFlag"
    ])
  }
};
</script>
<style  scoped>
#downapp {
  width: 750px;
  height: auto;
  background-image: url("../../assets/img/background@2x.png");
  padding: 0px 0px 40px 0px;
  background-size: 100% 100%;
}

.app-down-title {
  height: 58px;
  font-size: 42px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: rgba(245, 195, 167, 1);
  line-height: 58px;
  background: linear-gradient(
    148deg,
    rgba(233, 205, 181, 1) 0%,
    rgba(214, 170, 150, 1) 100%
  );
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  margin: 48px auto 44px;
}
.app-ba {
  width: 450px;
  height: 80px;
  font-size: 28px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(245, 195, 167, 1);
  line-height: 40px;
  margin: 0 auto 52px;
}

.app-ba img {
  width: 100%;
  height: 10px;
}

.app-ba-content {
  position: relative;
  top: -40px;
  font-size: 28px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(245, 195, 167, 0.5);
  line-height: 40px;
}
.foot-app {
  height: 40px;
  bottom: 5px;
}
.app-button{
  width: 300px;
  height: 61px;
  background: linear-gradient(90deg, #FFBFA1 0%, #FFE3D6 100%);
  opacity: 1;
  border-radius: 34px;
  font-size: 36px;
  font-family: PingFang SC;
  font-weight: bold;
  line-height: 50px;
  color: #542000;
  opacity: 1;
  border: none;
}
</style>


// WEBPACK FOOTER //
// src/components/page/downapptest.vue